import { useState, useCallback, useEffect } from 'react';
import time from '../utils/time';

export default function useCountdown(initialTime, onFinish) {
  const [isMounted, setMounted] = useState(true);
  const [intervalId, setIntervalId] = useState();
  const [currentTime, setCurrentTime] = useState(initialTime);

  const countDown = useCallback(() => {
    if (!isMounted) {
      return;
    }

    setCurrentTime((prevTime) => {
      const newTime = prevTime - 1;

      if (newTime <= 0) {
        clearInterval(intervalId);
        onFinish?.();
        return 0;
      }

      return newTime;
    });
  }, [setCurrentTime, onFinish]);

  useEffect(() => {
    setIntervalId(setInterval(countDown, 1000));

    return () => setMounted(false);
  }, [countDown, setIntervalId]);

  const reset = useCallback(
    (newTime) => {
      setCurrentTime(newTime || initialTime);
    },
    [setCurrentTime, initialTime]
  );

  return [time.formatSeconds.intoMinutes(currentTime), reset];
}
